import React, { FC, Fragment, useEffect, useState } from "react";
import { GalleryImage, HasEvent, LocationDeviceAndGal } from "../../../api/infomodul/models";
import APIRequest from "../../helpers/APIRequest";
import * as infomodul from '../../../api/infomodul';

interface Props {
    setSelectedTab: React.Dispatch<React.SetStateAction<number>>;
    locationData: LocationDeviceAndGal; 
    setGalleryData: React.Dispatch<React.SetStateAction<GalleryImage[]>>;
    runGetEvents: boolean;
    setRunGetEvents: React.Dispatch<React.SetStateAction<boolean>>;
    runGetGalleryImages: boolean;
    setRunGetGalleryImages: React.Dispatch<React.SetStateAction<boolean>>;
    setEventData: React.Dispatch<React.SetStateAction<HasEvent[]>>;
    masterId: number;
    updateLocationData: React.Dispatch<React.SetStateAction<boolean>>;
}

const GalleryList: FC<Props> = ({setSelectedTab, locationData, setGalleryData, runGetEvents, setRunGetEvents, runGetGalleryImages, setRunGetGalleryImages, setEventData, masterId, updateLocationData}) => {
    
    const [getGalImagesPending, setGetGalImagesPending] = useState(false);
    const [isPending, setIsPending] = useState(false);
    
    //Active gallery gets set by "setSelectedTab" and then collects galleryimages
    useEffect(() => {
        if (locationData.galleries.length > 0) {
            setSelectedTab(0);
            setRunGetGalleryImages(true);
        } else {
            //If there is no gallery, create a new one
            if(locationData.devices[0]) {
                infomodul.createGallery({
                    body: {
                        MasterId: masterId,
                        GalName: `Gallery${locationData.devices[0].masterPort}`,
                        Description: `Gallery${locationData.devices[0].masterPort}`,
                        Width: 800,
                        Height: 600,
                    }
                })
                updateLocationData(true);
                
                setSelectedTab(0);
            }
        }
    }, [locationData, setSelectedTab, setRunGetGalleryImages, masterId, updateLocationData])

    //Gets galleryimages
    const RequestGalleryImages = () => {
        return (
        <Fragment>{ locationData.galleries[0] &&
            <APIRequest<GalleryImage[]> 
              run={runGetGalleryImages} 
              setRun={setRunGetGalleryImages}
              pending={getGalImagesPending}
              setIsPending={setGetGalImagesPending} 
              req={() => infomodul.getGalleryImages({galleryId: locationData.galleries[0].id})}
              setData={setGalleryData}
          />}
          </Fragment>
        );
    }

    //Returns active events
    const GetActiveEvents = () => {
        return ( 
        <Fragment>{ locationData.galleries[0] &&
            <APIRequest<HasEvent[]> 
                run={runGetEvents} 
                setRun={setRunGetEvents}
                pending={isPending}
                setIsPending={setIsPending}
                req={() => infomodul.ActiveEvent({galleryId: locationData.galleries[0].id})}
                setData={setEventData}
            />}
            </Fragment>
        )
    }
    
    return (
        <Fragment>
            <RequestGalleryImages /> 
            <GetActiveEvents />
        </Fragment>
    );
}

export default GalleryList;